import React from 'react';

const LeaveConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay leave-confirm-overlay">
      <div className="modal-dialog leave-confirm-dialog">
        <div className="modal-header">
          <h2>Leave Meeting?</h2>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to leave this meeting?</p>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn-danger" onClick={onConfirm}>
            Leave
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveConfirmationModal;


